module.exports = __webpack_public_path__ + "static/media/go-back-arrow.754205dc.svg";